const operators = [
  {
    type: 'date',
    choices: [
      {
        label: 'Jour en cours',
        nbParam: 0,
      },
      /*            {
                label:"Egal",
                nbParam: 1
            },*/
      {
        label: 'Avant',
        nbParam: 1,
      },
      {
        label: 'Après',
        nbParam: 1,
      },
      {
        label: 'Mois dernier',
        nbParam: 0,
      },
      {
        label: 'Mois prochain',
        nbParam: 0,
      },
      {
        label: 'Ce mois-ci',
        nbParam: 0,
      },
      {
        label: 'Semaine en cours',
        nbParam: 0,
      },
      {
        label: 'Année dernière',
        nbParam: 0,
      },
      {
        label: 'Cette année',
        nbParam: 0,
      },
      {
        label: 'Est entre',
        nbParam: 2,
      },
    ],
  },
  {
    type: 'picklist',
    choices: [
      {
        label: 'Fait partie de',
        nbParam: 1,
      },
      {
        label: 'Ne fait pas partie de',
        nbParam: 1,
      },
    ],
  },
  {
    type: 'text',
    choices: [
      {
        label: 'Contient',
        nbParam: 1,
      },
      {
        label: 'Commence par',
        nbParam: 1,
      },
    ],
  },
  {
    type: 'numeric',
    choices: [
      {
        label: 'Supérieur à',
        nbParam: 1,
      },
      {
        label: 'Inférieur à ',
        nbParam: 1,
      },
      {
        label: 'Egal à ',
        nbParam: 1,
      },
      {
        label: 'Entre ',
        nbParam: 2,
      },
    ],
  },
  {
    type: 'boolean',
    choices: [
      {
        label: 'Oui',
        nbParam: 0,
      },
      {
        label: 'Non',
        nbParam: 0,
      },
    ],
  },
];

export default operators;
